import styled from 'styled-components';

export const CommunityContainer = styled.div`
  background-image: linear-gradient(to top, #fdecec, #fff);
  margin: 3em 0 0;
`;

export const Box = styled.div`
  background: #fff;
  border-radius: 20px;
  padding: 1.1em;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  text-align: left;
  height: 100%;
`;

export const Answer = styled.p`
  font-size: 16px;
  padding: 6px 0 4px;
  margin-bottom: 6px;
  color: rgb(0 0 0 / 80%);
  font-weight: 400;
  letter-spacing: 0.2px;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const Comments = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
  padding-bottom: ${(props) => props.paddingBottom};
  justify-content: space-between;
  padding: 0 18px;

  @media (max-width: 720px) {
    margin-left: ${(props) => props.marginLeft};
  }
  & span {
    padding-left: 4px;
    font-size: 12px;
    color: #0000008c;
    font-weight: 500;
  }

  & img {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
`;
